import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProductPreview } from './components/ProductPreview';
import { BestSellers } from './components/BestSellers';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProductPreview data-id="element-4" />
        <BestSellers data-id="element-5" />
        <Testimonials data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}